import EthnicityGenderPeopleChart from './EthnicityGenderPeopleChart';
export default EthnicityGenderPeopleChart;
